import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {MenuController} from "@ionic/angular";
import { Storage } from "@ionic/storage-angular";
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent implements OnInit {

  loggedin:any = 0;
  userid:any;
  constructor(private session: SessionService,private router: Router,
              private menu: MenuController,
              private storage: Storage,) { 

    this.session.myUserid$.subscribe((data:any) => {
        this.userid = data;
        this.storage.set("user_id", data);

        if(!this.userid || this.userid=='' || this.userid==undefined) {
            this.loggedin=0;
        } else {
            this.loggedin=1;
        }
    });

    this.init();

  }

  ngOnInit() {
  }

  async getLoginDetails() {

    this.userid = await this.storage.get('user_id');

    if(!this.userid || this.userid=='' || this.userid==undefined) {
        this.loggedin=0;
    } else {
        this.loggedin=1;
    }
  }

  async init() {
    //const storage = await this.storage.create();
    //this.storage = storage;
    this.getLoginDetails();
  }

  goHome() {
    this.router.navigate(['/']);
    this.menu.close();
    console.log('home');
  }
  goToRecharge() {
    this.router.navigate(['/recharge']);
    this.menu.close();
  }

  goToUtilityTransactions() {
    this.router.navigate(['/recharge-transactions']);
    this.menu.close();
  }

  goToMovies() {
    this.router.navigate(['/movies']);
    this.menu.close();
  }
  goToTheatres() {
    this.router.navigate(['theatres']);
    this.menu.close();
  }
  goToBookings() {
    this.router.navigate(['/home/bookings']);
    this.menu.close();
  }
  goToProfile() {
    this.router.navigate(['/home/profile']);
    this.menu.close();
  }
  goToComplaints() {
    this.router.navigate(['/home/complaints']);
    this.menu.close();
  }
  goToSettings() {
    this.router.navigate(['/home/settings']);
    this.menu.close();
  }
  goToQuiz() {
    this.router.navigate(['/home/quiz-list']);
    this.menu.close();
  }
  goToMyQuiz() {
    this.router.navigate(['/home/my-quiz-list']);
    this.menu.close();
  }
  goToMyVouchers() {
    this.router.navigate(['/home/my-vouchers']);
    this.menu.close();
  }
  goToMyReferrals() {
    this.router.navigate(['/referrals']);
    this.menu.close();
  }
  goTorReferFriend() {
    this.router.navigate(['/reffer-text-friend']);
    this.menu.close();
  }
  goToHowToUse() {
    this.router.navigate(['/how-to-use']);
    this.menu.close();
  }
  goToAbout() {
    this.router.navigate(['/about']);
    this.menu.close();
  }
  goToMyBuyVouchers() {
    this.router.navigate(['/mybuyvouchers']);
    this.menu.close();
  }
  goToTerms() {
    this.router.navigate(['/terms']);
    this.menu.close();
  }
  goToVouchers() {
    this.router.navigate(['/buy-vouchers']);
    this.menu.close();
  }
  async signOut() {
    await this.storage.clear();
    this.session.myUserid('');
    this.router.navigate(["/sign-in"]);
    console.log(this.storage);
    console.log(this.storage.get("user_id"), "check if user-id");
    this.menu.close();
  }

  public set(key: string, value: any) {
    this.storage?.set(key, value);
  }

  signin() {
    this.router.navigate(["/sign-in"]);
    this.menu.close();
  }
}
